export default __webpack_public_path__ + "static/media/End to End Support.95d2020f.svg";